import { useNotification } from "components/Notification/useAddNotification";

export const useEditUserAppointmentNotification = () => {
    const { addNotification } = useNotification();
    const notificationTitle = "Zmiana terminu";

    const showSuccessNotification = () =>
        addNotification({
            title: notificationTitle,
            description: `Pomyślnie zmieniono termin wizyty`,
            type: "success",
        });

    const showErrorNotification = (errorMsg?: string) =>
        addNotification({
            title: notificationTitle,
            description: errorMsg || "Nie udało się edytować wizyty",
            type: "error",
        });

    return { showSuccessNotification, showErrorNotification };
};
